/**
 * @desc createInDetailWithBox
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.CreateInDetailWithBoxRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/inmaster/createInDetailWithBox`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
